<template lang='pug'>
  .bf-divider.component
    .text
      span.border
      span {{$t ("Or") }}
      span.border
</template>

<script>
  export default {
    name: 'bf-divider'
  }
</script>

<style lang='stylus'>
  .bf-divider
    width 100%
    border-top 1px solid rgba( 0 0 0 .05 )
    border-bottom 1px solid white
    .text
      display none

    &.on-dark
      border-top 1px solid rgba( 0 0 0 .16 )
      border-bottom 1px solid rgba( 255 255 255 .12 )

    &.with-text
      border 0
      display flex
      width 100%
      min-height 1px
      border-top 1px solid rgba( 0 0 0 .15 )
      .text
        color black
        display block
        margin 0 auto
        background white
        margin-top -.7em
        padding 0 16px
        font-weight bold
        
    &.page
      margin 64px 0
      &.with-text
        margin-bottom 56px

    &.section
      margin 32px 0
      &.with-text
        margin-bottom 24px

    &.em-1
      margin 1em 0

    &.mini
      margin 4px 0

    &.card
      margin 16px 0

    &.tight
      margin 8px 0

    &.borderless
      border 0
</style>
